<template>
  <v-row>
    <v-col cols="12">
      <v-row align="center" justify="space-between">
        <v-col cols="12" md="6">
          <h1>Погодные условия</h1>
        </v-col>
        <v-col cols="12" md="6" class="text-right">
          <v-btn color="primary" @click="openForm()">
            <v-icon left>mdi-plus</v-icon>
            Создать
          </v-btn>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :items-per-page="-1"
          :footer-props="footerProps"
          no-data-text="Пусто"
          loading-text="Загрузка..."
      >
        <template #item.icon="{ item }">
          <img
              v-if="isImageIcon(item.icon)"
              :src="item.icon"
              width="28"
              height="28"
              style="object-fit:contain"
          />
          <v-icon v-else-if="item.icon">{{ item.icon }}</v-icon>
          <span v-else class="grey--text">-</span>
        </template>

        <template #item.actions="{ item }">
          <div class="text-right">
            <v-btn icon small @click="openForm(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small color="error" @click="openDelete(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="formDialog" max-width="620">
      <v-card>
        <v-card-title>{{ form.id ? 'Редактирование' : 'Создание' }}</v-card-title>
        <v-card-text>
          <v-text-field
              v-model="form.text"
              label="Текст для фразы"
              outlined
          />
          <v-text-field
              v-model="form.text_ua"
              label="Текст для фразы UA"
              outlined
          />
          <v-text-field
              v-model="form.icon"
              label="Иконка (URL)"
              outlined
              readonly
              clearable
              hint="Выберите иконку из списка"
              persistent-hint
          >
            <template #append>
              <v-menu offset-y>
                <template #activator="{ on, attrs }">
                  <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon>mdi-emoticon-happy-outline</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-card-text>
                    <div class="emoji-grid">
                      <v-btn
                          v-for="emoji in emojiIcons"
                          :key="emoji.url"
                          text
                          icon
                          :title="emoji.name || emoji.label"
                          @click="form.icon = emoji.url"
                      >
                        <img :src="emoji.url" width="28" height="28" style="object-fit:contain" />
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-menu>
            </template>
          </v-text-field>
          <div v-if="form.icon" class="icon-preview text-center pa-4 mb-4">
            <img
                v-if="isImageIcon(form.icon)"
                :src="form.icon"
                width="64"
                height="64"
                style="object-fit:contain"
            />
            <v-icon v-else size="64">{{ form.icon }}</v-icon>
            <div class="text-caption grey--text">Превью иконки</div>
          </div>
          <v-file-input
              v-model="iconUploadFile"
              label="Загрузить новую иконку"
              accept="image/png,image/jpeg,image/webp,image/svg+xml"
              outlined
              prepend-icon=""
              append-icon="mdi-attachment"
              :loading="uploadingIcon"
              @change="uploadIcon"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="formDialog = false">Отмена</v-btn>
          <v-btn color="primary" :loading="saving" :disabled="uploadingIcon" @click="submitForm">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="420">
      <v-card>
        <v-card-title>Удалить условие?</v-card-title>
        <v-card-text>
          {{ deleteItem ? deleteItem.text : '' }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="deleteDialog = false">Отмена</v-btn>
          <v-btn color="error" :loading="saving" @click="deleteCondition">Удалить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" top right>
      {{ snackbar.message }}
    </v-snackbar>
  </v-row>
</template>

<script>
import BadDeliveryConditionService from '@/api/BadDeliveryConditionService'

export default {
  name: 'BadDeliveryConditionIndex',
  data() {
    return {
      loading: false,
      saving: false,
      formDialog: false,
      deleteDialog: false,
      deleteItem: null,
      form: this.emptyForm(),
      items: [],
      iconUploadFile: null,
      uploadingIcon: false,
      emojiIcons: [
        { label: 'Снежинка', url: 'https://vilki-palki.od.ua/storage/emoji/snowflake_2744-fe0f.png' },
        { label: 'Огонь', url: 'https://vilki-palki.od.ua/storage/emoji/fire_1f525.png' },
        { label: 'Столкновение', url: 'https://vilki-palki.od.ua/storage/emoji/collision_1f4a5.png' },
        { label: 'Лед', url: 'https://vilki-palki.od.ua/storage/emoji/ice_1f9ca.png' },
        { label: 'Звезда', url: 'https://vilki-palki.od.ua/storage/emoji/star_2b50.png' },
        { label: 'Календарь', url: 'https://vilki-palki.od.ua/storage/emoji/calendar_1f4c5.png' },
        { label: 'Напиток', url: 'https://vilki-palki.od.ua/storage/emoji/cup-with-straw_1f964.png' },
        { label: 'Пляж', url: 'https://vilki-palki.od.ua/storage/emoji/beach-with-umbrella_1f3d6-fe0f.png' },
        { label: 'Подарок', url: 'https://vilki-palki.od.ua/storage/emoji/wrapped-gift_1f381.png' },
        { label: 'Новинка', url: 'https://vilki-palki.od.ua/storage/emoji/new-button_1f195.png' },
        { label: 'Повар', url: 'https://vilki-palki.od.ua/storage/emoji/man-cook_1f468-200d-1f373.png' },
        { label: 'Тарелка', url: 'https://vilki-palki.od.ua/storage/emoji/fork-and-knife-with-plate_1f37d-fe0f.png' },
        { label: 'Палочки', url: 'https://vilki-palki.od.ua/storage/emoji/chopsticks_1f962.png' },
        { label: 'Торт', url: 'https://vilki-palki.od.ua/storage/emoji/birthday-cake_1f382.png' },
        { label: 'Сердце в огне', url: 'https://vilki-palki.od.ua/storage/emoji/heart-on-fire_2764-fe0f-200d-1f525.png' },
        { label: 'Сердце руками', url: 'https://vilki-palki.od.ua/storage/emoji/heart-hands_1faf6.png' },
        { label: '🚧', url: 'https://nommy.od.ua/storage/emoji/construction_1f6a7.png' },
        { label: '⛈️', url: 'https://nommy.od.ua/storage/emoji/cloud-with-lightning-and-rain_26c8-fe0f.png' },
      ],
      footerProps: {
        itemsPerPageText: 'Элементов на странице',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [-1]
      },
      headers: [
        { text: 'ID', value: 'id', width: '80px' },
        { text: 'Иконка', value: 'icon', sortable: false, width: '120px' },
        { text: 'Текст для фразы', value: 'text' },
        { text: 'Текст для фразы UA', value: 'text_ua' },
        { text: 'Действия', value: 'actions', sortable: false, width: '120px' }
      ],
      snackbar: {
        show: false,
        message: '',
        color: 'success'
      }
    }
  },
  mounted() {
    this.fetchItems()
    this.fetchIcons()
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        text: '',
        text_ua: '',
        icon: '',
        sort_order: 0
      }
    },
    async fetchItems() {
      this.loading = true
      try {
        const response = await BadDeliveryConditionService.list()
        this.items = response.data
      } finally {
        this.loading = false
      }
    },
    openForm(item = null) {
      this.form = item ? {
        id: item.id,
        text: item.text,
        text_ua: item.text_ua,
        icon: item.icon,
        sort_order: item.sort_order,
      } : this.emptyForm()
      this.iconUploadFile = null
      this.formDialog = true
    },
    async fetchIcons() {
      try {
        const response = await BadDeliveryConditionService.icons()
        const icons = new Map(this.emojiIcons.map(icon => [icon.url, icon]))
        response.data.forEach(icon => icons.set(icon.url, icon))
        this.emojiIcons = Array.from(icons.values())
      } catch (error) {
        this.showMessage('Не удалось загрузить список иконок', 'error')
      }
    },
    async uploadIcon(file) {
      if (!file) return
      this.uploadingIcon = true
      const form = this.form
      try {
        const response = await BadDeliveryConditionService.uploadIcon(file)
        if (this.form === form) this.form.icon = response.data.url
        await this.fetchIcons()
        this.showMessage('Иконка загружена')
      } catch (error) {
        this.showMessage('Не удалось загрузить иконку. Попробуйте снова.', 'error')
      } finally {
        this.uploadingIcon = false
        this.iconUploadFile = null
      }
    },
    async submitForm() {
      this.saving = true
      try {
        if (this.form.id) {
          await BadDeliveryConditionService.update(this.form.id, this.form)
        } else {
          await BadDeliveryConditionService.create(this.form)
        }
        this.formDialog = false
        this.showMessage('Сохранено')
        await this.fetchItems()
      } finally {
        this.saving = false
      }
    },
    openDelete(item) {
      this.deleteItem = item
      this.deleteDialog = true
    },
    async deleteCondition() {
      if (!this.deleteItem) {
        return
      }
      this.saving = true
      try {
        await BadDeliveryConditionService.remove(this.deleteItem.id)
        this.deleteDialog = false
        this.showMessage('Удалено')
        await this.fetchItems()
      } finally {
        this.saving = false
      }
    },
    showMessage(message, color = 'success') {
      this.snackbar = {
        show: true,
        message,
        color
      }
    },
    isImageIcon(icon) {
      return typeof icon === 'string' && /^https?:\/\//.test(icon)
    }
  }
}
</script>

<style scoped>
.emoji-grid {
  display: grid;
  grid-template-columns: repeat(4, 40px);
  gap: 8px;
}

.icon-preview {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
</style>
